/**
 * 向き付き直方体の姿勢と、描画順のユーティリティ。
 * 範囲破壊プレビューなど、保存しない一時形状でも使う。
 */

import type { EntityType, Vec3 } from './types';
import { BLOCK_YAW_DEGREES, snapYawClass, yawClassDegrees } from './view-grid';

export { BLOCK_YAW_DEGREES, snapYawClass, yawClassDegrees };

/** 描画・当たり判定・範囲プレビュー用。保存しない。 */
export interface BlockPose {
  origin: Vec3;
  size: Vec3;
  yaw: number;
  yawClass: number;
}

/**
 * 向き・形状による Z-fighting 回避は切っている。呼び出し側の式はそのまま残す。
 */
export const BLOCK_YAW_ZFIGHT_BIAS = 0;

/** 向き・形状による描画 rank は切っている。 */
export function entityDrawRank(_type: EntityType, _yawClass = 0): number {
  return 0;
}

/** 透明は不透明の後に描く。 */
export const ENTITY_DRAW_TRANSPARENT_OFFSET = 1;

export function entityRenderOrder(_rank: number, transparent: boolean): number {
  return transparent ? ENTITY_DRAW_TRANSPARENT_OFFSET : 0;
}

/** 向き・形状による polygonOffset は切っている。 */
export function entityDepthBias(_rank: number): { factor: number; units: number } | null {
  return null;
}
